import { QueryParamsEntitiesV3 } from "@/domain/entities/MainApp";

export class ListSttRequestPickupRequest {
  page = 1;
  limit = 10;
  isTotalData = true;
  sttNo = "";
  isUnlinkedShipment = true;
  status = "BKD";
  search = "";

  constructor(fields?: Partial<ListSttRequestPickupRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(this).queryString;
  }
}

export class PickupCorporateSummaryRequest {
  clientCode = "";
  constructor(fields?: Partial<PickupCorporateSummaryRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(this).queryString;
  }
}

export class ListPickupParams {
  shipmentId = "";
  pickupSchedule = "";
  createdAtFrom = "";
  createdAtTo = "";
  transportType = "";
  serviceCode = "";
  lastStatus = "";
  sortBy = "";
  page = 1;
  perPage = 10;
  isTotalData = true;

  constructor(fields?: Partial<ListPickupParams>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntitiesV3(this).queryString;
  }
}
